import React from "react";
import createBrowserHistory from "history/createBrowserHistory";
import "react-datepicker/dist/react-datepicker.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-select-search/style.css"
import "src/app.css"
import { observer, Provider } from "mobx-react";
import { RootStore } from "src/stores/RootStore";
import { HistoryAdapter } from "mobx-state-router";
import "mobx-react-lite/batchingForReactDom";
import {Shell} from "src/Shell";

let root: RootStore;

const ensureInitialized = () => {
    if (root) return;
    root = new RootStore();
    const historyAdapter = new HistoryAdapter(root.routerStore, createBrowserHistory());
    historyAdapter.observeRouterStateChanges();
};

export const App = observer(() => {
    ensureInitialized();
    const route = root.routerStore.routerState.routeName;
    return (
        <Provider rootStore={root}>
            <Shell/>
        </Provider>
    );
});
